import React from "react";
import { useSelector } from "react-redux";
import { Trans, useTranslation } from "react-i18next";
import { getNameFromLocale } from "../../helper";
import i18n from "../../services/i18n";
import CollapsibleTextSection from "./CollapsibleTextSection";

// The cancellation policy and the agreement with the terms, accepted before
// any way of paying.
const PaymentTerms = ({ isChecked, setChecked, error }) => {
  const { t } = useTranslation();
  const { selectedProperty } = useSelector((state) => state?.search);

  return (
    <div className='termConditionWrapper payment-terms'>
      <CollapsibleTextSection
        title={t("cancellation_policy", "Cancellation policy")}
        html={getNameFromLocale(selectedProperty?.cancellation_policy, i18n.resolvedLanguage)}
        className='checkout-cancellation-policy'
      />

      <div className='checkBoxWrap'>
        <input
          type='checkbox'
          id='terms_and_conditions'
          checked={isChecked}
          onChange={(event) => setChecked(event.target.checked)}
        />
        <label htmlFor='terms_and_conditions' className='formConfirmText'>
          <Trans
            i18nKey='agreement'
            components={{
              1: <a href='#'>{t("terms")}</a>,
              2: <a href='#'>{t("privacy")}</a>,
            }}
          />
        </label>
      </div>
      {error && <p className='error-message'>{error}</p>}
    </div>
  );
};

export default PaymentTerms;
